export default __webpack_public_path__ + "static/media/grata-stack3.webp";